import React from "react";
import "./BackBtn.css";
import { useNavigate } from "react-router-dom";

export default function BackBtn() {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  return (
    <div className="backBtn" onClick={goBack}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 34 34"
        fill="none"
        className="backBtnSvg"
      >
        <path
          d="M21.8 1L12.2 1C4.20001 1 1.00001 4.2 1.00001 12.2L1.00001 21.8C1 29.8 4.2 33 12.2 33L21.8 33C29.8 33 33 29.8 33 21.8L33 12.2C33 4.2 29.8 1 21.8 1Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.0156 11.3517L13.3836 16.9997L19.0156 22.6477"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}
